// export const API_URL = 'http://162.222.203.236:4090/';
// For Local Use of API
export const API_URL= 'https://api.jcsoftwaresolution.in/'
export const SHOW_FILE = "SHOW_FILE"
export const LOGIN_USER = "LOGIN_USER"

export const LOGOUT_USER = "LOGOUT_USER"
